export default "__VITE_ASSET__5e177ab2__"